import { Box, Grid } from "@mui/material";
import { cloudfrontUrl } from "../../../constants/imageUrl";
import useIsMobile from "../../../hooks/useIsMobile";

export default function Contact() {
  const isMobile = useIsMobile("md");

  const mapIframeSrc =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2886.574066717563!2d7.1954112775399395!3d43.65702935218107!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12cdd1004efdeb1d%3A0xae76a78e80c10dda!2sKorean%20Street%20Market!5e0!3m2!1sen!2sfr!4v1763543577217!5m2!1sen!2sfr";

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Grid
        container
        spacing={isMobile ? 2 : 4}
        sx={{
          height: "100%",
          backgroundColor: "#ff0009",
          mt: 1,
          pb: 10,
          px: { xs: 2, md: 6 },
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: isMobile ? "center" : "flex-start",
            alignItems: "flex-start",
          }}
        >
          <Box
            component="img"
            src={`${cloudfrontUrl}/about/ksm_website_aboutus_label.png`}
            alt="KSM Label"
            sx={{
              width: isMobile ? "100%" : "30%",
              height: "auto",
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: isMobile ? "center" : "flex-start",
            justifyContent: "flex-end",
            gap: 0,
            height: "100%",
          }}
        >
          <Box
            component="img"
            src={`${cloudfrontUrl}/about/ksm_website_aboutus_map_label.png`}
            alt="KSM Label"
            sx={{
              width: isMobile ? "85%" : "55%",
              height: "auto",
              maxWidth: 360,
            }}
          />
          <Box
            component="iframe"
            src={mapIframeSrc}
            title="KSM 위치"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            sx={{
              border: 0,
              width: "100%",
              minHeight: isMobile ? 320 : 720,
              borderRadius: 2,
              boxShadow: "0px 12px 24px rgba(0, 0, 0, 0.15)",
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={7}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          <Box
            component="img"
            src={`${cloudfrontUrl}/about/ksm_website_about_info.png`}
            alt="KSM Info"
            sx={{
              width: isMobile ? "100%" : "90%",
              height: "auto",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
